import { View, XStack } from "tamagui";

import {
  useIsChatMutationPending,
  useSendNoriMessage,
} from "@/api/mutations/conversation";
import { Suggestion } from "@/components";
import { useConversationComposition } from "@/store/conversation";

export default function SingleSelectInputControl({ ...props }) {
  const { sendNoriMessage } = useSendNoriMessage();
  const isPending = useIsChatMutationPending();
  const { inputControl } = useConversationComposition();

  const suggestions = inputControl?.suggestions ?? [];

  if (inputControl?.type !== "suggestions") return null;
  return (
    <View data-purpose="anchor-suggestions" marginVertical="$200" {...props}>
      <XStack
        gap={"$200"}
        flexWrap="wrap"
        justifyContent="flex-end"
        alignItems="flex-end"
      >
        {suggestions.map((suggestion) => (
          <Suggestion
            key={suggestion}
            text={suggestion}
            onPress={() => sendNoriMessage(suggestion)}
            disabled={isPending}
            mode="secondary"
          />
        ))}
      </XStack>
    </View>
  );
}
